import React from "react";
import Image from "components/image";

const PromoBanner = ({ data }) => {
	const { image, mobileImage } = data || {};

	return (
		<div className="pt-5 md:pt-7">
			<Image image={image} className="hidden sm:flex" />
			<Image image={mobileImage} className="sm:hidden" />
		</div>
	);
};

export default PromoBanner;
